import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {loadBdms, saveBdmClient, deleteBdmClient} from '../../actions/bdmActions';
import { Button } from 'reactstrap';
import Select from 'react-select';
import {toastr} from 'react-redux-toastr';
import {apiRequest} from '../../utils/request';

class BdmsPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      selectedBdm: null,
      clientSearch: '',
    };

    this.handleBdmChange = this.handleBdmChange.bind(this);
    this.getClients = this.getClients.bind(this);
    this.handleSelectClient = this.handleSelectClient.bind(this);
    this.handleRemoveBdmClient = this.handleRemoveBdmClient.bind(this);
  }

  handleBdmChange(val) {
    this.setState({selectedBdm: val});
  }

  handleSelectClient(val){
    this.props.dispatch(saveBdmClient(this.state.selectedBdm, val));
  }

  handleRemoveBdmClient(val){
    this.props.dispatch(deleteBdmClient(this.state.selectedBdm, val));
  }

  getClients(input) {
    if (!input) {
      return Promise.resolve({options: []});
    }
    return apiRequest(`/api/clients/forbdm?name=${input}`)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Getting clients, error: ${x.error ? x.error : x.data.Message}`);
          return {options: []};
        } else {
          return {options: x.data};
        }
      });
  }

  static getDerivedStateFromProps(props, state) {
    if (state.selectedBdm) {
      return {
        selectedBdm: props.bdms.items.filter(x => x.id === state.selectedBdm.id)[0],
      };
    }
    return null;
  }

  componentDidMount() {
    this.props.dispatch(loadBdms());
  }  

  render(){
    let {bdms} = this.props;
    let {selectedBdm} = this.state;
    
    return (<div>
      <div className="row">
        <div className="col-md-12">
          <h4>Manage BDMs</h4>
        </div>
      </div>

      <div className="row">&nbsp;</div>
      <div className="row">
        <div className="col-md-12">
          <div className="form-horizontal">
            <div className="form-group row">
              <label className="col-md-2 form-control-label"  htmlFor="name">Select BDM</label>
              <div className="col-md-8">
                <Select
                  name="bdms"
                  value={selectedBdm}
                  multi={false}
                  simpleValue={false}
                  options={bdms.items}
                  valueKey={'id'}
                  labelKey={'fullName'}
                  onChange={this.handleBdmChange}
                  placeholder="Select BDM"
                />
              </div>
            </div>
            {selectedBdm &&
            <div className="form-group row">
              <label className="col-md-2 form-control-label"  htmlFor="name">Add client</label>
              <div className="col-md-8">
                <Select.Async
                  name="clients"
                  multi={false}
                  simpleValue={false}
                  loadOptions={this.getClients}
                  valueKey={'id'}
                  labelKey={'clientName'}
                  onChange={this.handleSelectClient}
                  value={this.state.clientSearch}
                  placeholder="Find Client"

                />
              </div>
            </div>}
          </div>

        </div>
      </div>
      <div className="row">&nbsp;</div>

      {selectedBdm && <div className="container">
        <div className="row">
          <table className="table table-responsive table-striped">
            <thead>
            <tr>
              <th>Client Name</th>
              <th>&nbsp;</th>
            </tr>
            </thead>
            <tbody>
            {selectedBdm.clients.length===0 && <tr><td>There are no clients assigned</td><td>&nbsp;</td></tr>}
            {selectedBdm.clients.map(x => {
              return (<tr key={x.id}>
                <td>{x.clientName}</td>
                <td><Button color="danger" onClick={() => this.handleRemoveBdmClient(x)}><i className="fa fa-times" /></Button></td>
              </tr>);
            })}
            </tbody>
          </table>
        </div>
      </div> }
    </div>);
  }
}

BdmsPage.propTypes = {

};

function mapStateToProps(state){
  return {
    bdms: state.bdms,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BdmsPage);
